module.exports = __webpack_public_path__ + "static/media/SC.b6580a30.png";


//////////////////
// WEBPACK FOOTER
// ./src/invitation/index/image/SC.png
// module id = 961
// module chunks = 0